import type { FeatureFlags } from 'shared/api/containerApi/requests/getFeatureFlags'
import { getIsInsideIframe } from 'shared/utils/getIsInsideWindow'

/**
 * A container running inside a window iframe reuses the flags its parent
 * container already loaded instead of fetching them again.
 */
export const readParentFeatureFlags = (): FeatureFlags | undefined => {
  if (!getIsInsideIframe()) return undefined
  try {
    return window.parent.__CONTAINER_FEATURE_FLAGS__
  } catch {
    return undefined
  }
}
